import Result, { EmptyResult } from '@package/services/src/Result';

import { CouponCodeService } from './services';
import { CouponCode, CouponCodeRequest, GetCouponCodeRequest } from './types';

export default class CouponCodeInteractor {
  public constructor(private readonly couponCodeService: CouponCodeService) {}

  public getCouponCode(request?: GetCouponCodeRequest): Promise<Result<CouponCode | null>> {
    return this.couponCodeService.getCouponCode(request);
  }

  public applyCouponCode(request: CouponCodeRequest): Promise<Result<boolean | undefined>> {
    return this.couponCodeService.applyCouponCode(request);
  }

  public deleteCouponCode(request: CouponCodeRequest): Promise<EmptyResult | undefined> {
    return this.couponCodeService.deleteCouponCode(request);
  }
}
